import { Foto as Imagem } from '../../../compartilhado/Foto';

/**
 * O quadro da foto do prêmio, do jeito do APP da cliente.
 *
 * A mesma decisão aparece em quatro lugares (a lojinha, o detalhe, a próxima
 * recompensa e a prateleira da carteira), e quatro cópias divergiriam no
 * primeiro ajuste: uma ganharia `loading="lazy"`, outra não; uma teria `alt`,
 * outra ficaria muda para o leitor de tela.
 *
 * ⚠️ **O vazio não é erro.** Prêmio sem foto é normal — brinde que não é peça
 * do catálogo, SKU ainda não vinculado, peça sem imagem. Nesses casos fica o
 * hachurado que já existia, sem aviso e sem ícone de quebrado: para a cliente,
 * "este prêmio não tem foto" não é uma informação que ela precise processar.
 *
 * O contêiner é sempre desenhado — é ele que carrega o hachurado no CSS, e é
 * dentro dele que a imagem entra. Quem cuida da imagem (lazy, link quebrado) é
 * `compartilhado/Foto.tsx`, o mesmo que a escada de prêmios do painel usa.
 */
export function Foto({
  capa,
  nome,
  className,
}: {
  capa: string | null;
  /** Vira o `alt`. É o nome do prêmio, que é o que a foto mostra. */
  nome: string;
  className: string;
}) {
  return (
    <div className={className}>
      {/* O texto "foto" é a legenda do hachurado, não um erro. */}
      <Imagem capa={capa} alt={nome} vazio="foto" />
    </div>
  );
}
